<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">Sobre percepción del daño</h4>

    <form-group :error="errors.has('afectacion') && submitted">
      <label class="form__label form__label--required">
        34. ¿Cómo califica el daño causado por los felinos en su propiedad?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.afectacion"
        id="muchoafectacion"
        name="afectacion"
        v-validate="'required'"
        value="Me afecta mucho">
        <label class="form__label" for="muchoafectacion">
          Me afecta mucho
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.afectacion"
        id="regularafectacion"
        name="afectacion"
        v-validate="'required'"
        value="Regular">
        <label class="form__label" for="regularafectacion">
          Regular
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.afectacion"
        id="pocoafectacion"
        name="afectacion"
        v-validate="'required'"
        value="Me afecta poco">
        <label class="form__label" for="pocoafectacion">
          Me afecta poco
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.afectacion"
        id="contrarioafectacion"
        name="afectacion"
        v-validate="'required'"
        value="Al contrario, me gusta saber que hay felinos en mi propiedad">
        <label class="form__label" for="contrarioafectacion">
          Al contrario, me gusta saber que hay felinos en mi propiedad
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('amenazaParaPersonas') && submitted">
      <label class="form__label form__label--required">
        35. ¿Considera a los felinos/cánidos como una amenaza para las personas?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.amenazaParaPersonas"
        id="siamenazaParaPersonas"
        name="amenazaParaPersonas"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="siamenazaParaPersonas">
          Si
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.amenazaParaPersonas"
        id="noamenazaParaPersonas"
        name="amenazaParaPersonas"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="noamenazaParaPersonas">
          No
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('condiciones-permiso') && submitted">
      <label class="form__label form__label--required">
        36. Bajo qué condiciones permitiría que estos felinos
        sigan frecuentando su propiedad? (NO leerle las opciones,
        hacerlo a modo de diálogo y marque lo que usted interpretó)
      </label>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="1condicionesPermiso" name="condiciones-permiso"
        v-model="form.condicionesPermiso" value="No lo permitiría jamás">
        <label class="form__label" for="1condicionesPermiso">
          No lo permitiría jamás
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="2condicionesPermiso" name="condiciones-permiso"
        v-model="form.condicionesPermiso" value="Si hay menos ataques en la propiedad">
        <label class="form__label" for="2condicionesPermiso">
          Si hay menos ataques en la propiedad
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="3condicionesPermiso" name="condiciones-permiso"
        v-model="form.condicionesPermiso" value="Si le dan algún beneficio extra por conservarlos">
        <label class="form__label" for="3condicionesPermiso">
          Si le dan algún beneficio extra por conservarlos
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="4condicionesPermiso" name="condiciones-permiso"
        v-model="form.condicionesPermiso" value="Si le reponen económicamente los animales">
        <label class="form__label" for="4condicionesPermiso">
          Si le reponen económicamente los animales
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="5condicionesPermiso" name="condiciones-permiso"
        v-model="form.condicionesPermiso" value="No tiene problema de que estén en
        la propiedad pero que no ataquen a los perros">
        <label class="form__label" for="5condicionesPermiso">
          No tiene problema de que estén en la propiedad pero que no ataquen a los perros
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('oido-uacfel') && submitted">
      <label class="form__label form__label--required">
        37. ¿Ha oído hablar de la UACFel?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.oidoUacfel"
        id="sioido-uacfel"
        name="oido-uacfel"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="sioido-uacfel">
          Si
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.oidoUacfel"
        id="nooido-uacfel"
        name="oido-uacfel"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="nooido-uacfel">
          No
        </label>
      </div>
      <div class="identado">
        <form-group :error="errors.has('como-escucho-uacfel') && submitted"
        v-if="form.oidoUacfel">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.comoEscuchoUacfel"
          name="como-escucho-uacfel"
          required
          v-validate="'required'">
          <label class="form__label">
            ¿Dónde o cómo escuchó?
          </label>
        </form-group>
      </div>
    </form-group>

    <form-group :error="errors.has('participacion-proyectos') && submitted">
      <label class="form__label form__label--required">
        38. ¿Estaría usted dispuesto a participar en un proyecto para mejorar el manejo de
        sus perros y evitar futuros ataques de depredación? (NO mencione la ayuda económica
        ni prometa nada)
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.participacionProyectos"
        id="siparticipacion-proyectos"
        name="participacion-proyectos"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="siparticipacion-proyectos">
          Si
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.participacionProyectos"
        id="noparticipacion-proyectos"
        name="participacion-proyectos"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="noparticipacion-proyectos">
          No
        </label>
      </div>
    </form-group>

  </form>
</template>

<script>
export default {
  name: "FormPerrosBloque5",
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
  methods: {
    validar,
  },
};

function validar() {
  return this.$validator.validate();
}
</script>
